// extracted by mini-css-extract-plugin
export var numpadContainer = "_pb-1";
export var phoneButton = "_pb-0";